import columns from 'utils/columns/equipments';
import { initialStateFactory, reducerFactory, sagasFactory } from 'utils/factories';

import actionsFactory from 'utils/factories/actions';
import { EQUIPMENT } from './actionTypes';

// actions
const actions = actionsFactory(EQUIPMENT);
export { actions };

// reducer
const initialState = initialStateFactory(columns);
const reducer = reducerFactory(EQUIPMENT);
export default (state = initialState, action) => reducer(state, action);

// sagas
const sagas = sagasFactory(EQUIPMENT, '/equipment');
export { sagas };
